import { modules } from "@core/utils/modules.js";

export default [
  {
    path: "attendance",
    name: "treasury-attendance",
    redirect: { name: "treasury-attendance-report" },
    component: () => import("@/views/treasury/views/treasury-attendance/TreasuryAttendanceMain.vue"),
    meta: {
      section: 20,
      module: modules.TREASURY,
    },
    children: [
      {
        path: "report",
        name: "treasury-attendance-report",
        component: () =>
          import(
            /* webpackChunkName: "TreasuryAttendanceReportTable" */ "@/views/commons/employee_attendance/AttendanceReportTable.vue"
          ),
        meta: {
          section: 20,
          pageTitle: "Attendance",
          module: modules.TREASURY,
        },
      },
    ],
  },
];